import { POStatus } from "./PurchaseOrder"

export const JobType = [
    { name: "-- SELECT --" },
    { name: "Onsite" },
    { name: "Hybrid" },
    { name: "Remote" },
]
export const Term = [
    { name: "-- SELECT --" },
    { name: "Contract" },
    { name: "Contract-to-Hire" },
    { name: "Permanent" },
]
export const Priority = [
    { name: "-- SELECT --" },
    { name: "High" },
    { name: "Low" },
    { name: "Very High" },
]
export const InterviewProcess = [
    { name: "-- SELECT --" },
    { name: "Telephonic" },
    { name: "F2F" },
    { name: "Skype" },
    { name: "Tele + F2F" },
    { name: "Skype + F2F" },
    { name: "Tel/Skype + F2F" },
    { name: "Telephonic / F2F" },
    { name: "Tel/Webex" },
    { name: "Tel/Zoom" },
    { name: "Tel/Spark Hire" },
]
export const EClient_Communication = [
    { name: "-- SELECT --" },
    { name: "Phone" },
    { name: "Email" },
    { name: "Chat" },
]
export const PO_Status = [
    { name: "-- SELECT --", id: null },
    { name: "To Join", id: POStatus.To_Join },
    { name: "Fizzled", id: POStatus.Fizzled },
    { name: "Joined", id: POStatus.Joined },
    { name: "Ended", id: POStatus.Ended },
]
export const POStatusMap = Object.fromEntries(
    PO_Status.map(x => [x.id, x.name])
);
export const PODocType = [
    { name: "Consultant" },
    { name: "Vendor" },
    // { name: "Client" },
]
export const ECIType = [
    { name: "Telephonic" },
    { name: "In Person" },
    { name: "Skype" },
    { name: "Tele + F2F" },
    { name: "Skype + F2F" },
    { name: "Tel/Skype + F2F" },
    { name: "Telephonic / F2F" },
]
export const Positions = [
    { name: "1" },
    { name: "2" },
    { name: "3" },
    { name: "4" },
    { name: "5" },
    { name: "6" },
    { name: "7" },
    { name: "8" },
    { name: "9" },
    { name: "10" },
    { name: "11" },
    { name: "12" },
    { name: "13" },
    { name: "14" },
    { name: "15" },
    { name: "16" },
    { name: "17" },
    { name: "18" },
    { name: "19" },
    { name: "20" }
]
export const Experience = [
    { name: 1 },
    { name: 2 },
    { name: 3 },
    { name: 4 },
    { name: 5 },
    { name: 6 },
    { name: 7 },
    { name: 8 },
    { name: 9 },
    { name: 10 },
    { name: 11 },
    { name: 12 },
    { name: 13 },
    { name: 14 },
    { name: 15 },
    { name: 16 },
    { name: 17 },
    { name: 18 },
    { name: 19 },
    { name: 20 }
]
export const NoticePeriod = [
    { value: "0", name: "Immediate" },
    { value: "7", name: "One Week" },
    { value: "15", name: "Two Week" },
    { value: "30", name: "One Month" },
    { value: "60", name: "Two Month" },
    { value: "90", name: "Three Month" }
]
export const TaxTerm = [
    { name: "C2C with Benefits" },
    { name: "C2C All Inclusive" },
    { name: "1099 All Inclusive" },
    { name: "1099 with Benefits" },
    { name: "W2 All Inclusive" },
    { name: "W2 with Benefits" },
    { name: "Permanent" }
]

export const MatchingPer = [
    { name: 50 },
    { name: 60 },
    { name: 70 },
    { name: 80 },
    { name: 90 },
    { name: 100 }
]
export const CblType = [
    { name: "Contract" },
    { name: "Permanent" },
    { name: "C2C" }
]
export const ServedStatus = [
    { name: "-- SELECT --" },
    { name: "Served" },
    { name: "Unserved" },
    { name: "UnAllocated" },
    { name: "Rejected" }
]
export const Status = [
    { name: "-- SELECT --" },
    { name: "Hold" },
    { name: "Unhold" }
]
export const TicketStatus = [
    { name: "Open" },
    { name: "InProgress" },
    { name: "Hold" },
    { name: "Answered" },
    { name: "Closed" }
]
